"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_NAME_SEPARATOR = '@$@';
exports.generateContextName = function (className, propName) {
    return "" + className + exports.CONTEXT_NAME_SEPARATOR + propName;
};
//# sourceMappingURL=generate-context-name.js.map